import React from "react";

export default function Header() {
  return (
    <div className="header">
      <h1>Remote Work Resources</h1>
      <h3>Curating the Best in Fully Remote Work Opportunities</h3>
    </div>
  );
}
